// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.register-form {
	height: 500px;
}

.login-button {
	margin-top: 15px;
}

.is-admin-checkbox {
	display: flex;
	align-items: center;
	font-size: 20px;
	height: 40px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/UserRegister/UserRegister.css"],"names":[],"mappings":"AAAA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,eAAe;CACf,YAAY;AACb","sourcesContent":[".register-form {\n\theight: 500px;\n}\n\n.login-button {\n\tmargin-top: 15px;\n}\n\n.is-admin-checkbox {\n\tdisplay: flex;\n\talign-items: center;\n\tfont-size: 20px;\n\theight: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
